module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/105-cameroon-be2d208a7df715b6198e661db90904f5.svg";